import React from 'react';
import { useGetProjectsQuery } from '../../features/api/apiSlice';
import ProjectCardLoader from '../ui/Loaders/ProjectCardLoader';
import ProjectCard from './ProjectCard';

const Projects = () => {
    const { data, isError, isLoading } = useGetProjectsQuery({ page: 0 })

    let content = null;
    if (isLoading) {
        content = (
            <div className="grid 2xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 md:gap-5 gap-2  md:px-4">
                <ProjectCardLoader/>
                <ProjectCardLoader/>
                <ProjectCardLoader/>
                <ProjectCardLoader/>
                <ProjectCardLoader/>
                <ProjectCardLoader/>
            </div>
        )
    }
    if (!isLoading && isError) {
        content = <h2 className=''>There was an error!!</h2>
    }
    if (!isLoading && !isError && data?.length === 0) {
        content = <h1 className=''>No Project found !</h1>
    }
    if (!isLoading && !isError && data?.length > 0) {
        content = (
            <div className="grid 2xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 md:gap-5 gap-2  md:px-4">
                {data.map((project, i) => <ProjectCard key={i} project={project} />)}
            </div>
        )
    }
    return (
        <div>
            {content}
        </div>
    );
};

export default Projects;